import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetRecommendationEvaluation = createAsyncThunk(
  "RecommendationEvaluation/GetRecommendationEvaluation",
  async (subTaskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/RecommendationEvaluation/GetRecommendationEvaluation",
        {
          subTaskFlowGUID: subTaskFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetRecommendationEvaluation");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetRecommendationsDropDown = createAsyncThunk(
  "RecommendationEvaluation/GetRecommendationsDropDown",
  async (flowIdModel, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/RecommendationEvaluation/GetRecommendationsDropDown",
        {
          flowGUID: flowIdModel.flowGUID,
          ApplicationInfo:flowIdModel.ApplicationInfo
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetRecommendationsDropDown");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateRecommendationEvaluation = createAsyncThunk(
  "RecommendationEvaluation/UpdateRecommendationEvaluation",
  async (RecommendationEvaluationList, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/RecommendationEvaluation/UpdateRecommendationEvaluation",
        {
          recommendationEvaluationGUID:
            RecommendationEvaluationList.recommendationEvaluationGUID,
          subTaskFlowGUID: RecommendationEvaluationList.subTaskFlowGUID,
          applicationGUID: RecommendationEvaluationList.applicationGUID,
          taskFlowGUID: RecommendationEvaluationList.taskFlowGUID,
          recommendationGUID: RecommendationEvaluationList.recommendationGUID,
          recommendationReason:
            RecommendationEvaluationList.recommendationReason,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaaaaaaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const RecommendationEvaluationManager = createSlice({
  name: "RecommendationEvaluationManager",
  initialState: {
    RecommendationEvaluationManager: {},
    loadingRecommendationEvaluationManager: false,
    errorRecommendationEvaluationManager: null,
    //------------------update-------------------
    RecommendationEvaluationManagerUpdate: {},
    loadingRecommendationEvaluationManagerUpdate: false,
    errorRecommendationEvaluationManagerUpdate: null,
    //----------GetRecommendationsDropDown---------------
    RecommendationEvaluationDropDown: [],
    loadingRecommendationEvaluationDropDown: false,
    errorRecommendationEvaluationDropDown: null,
  },
  reducers: {
    SetRecommendationEvaluationManager: (state, action) => {
      state.RecommendationEvaluationManager = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetRecommendationEvaluation.pending, (state, action) => {
        state.loadingRecommendationEvaluationManager = true;
        state.RecommendationEvaluationManager = action.payload;
        state.errorRecommendationEvaluationManager = null;
      })
      .addCase(GetRecommendationEvaluation.fulfilled, (state, action) => {
        state.loadingRecommendationEvaluationManager = false;
        state.RecommendationEvaluationManager = action.payload;
      })
      .addCase(GetRecommendationEvaluation.rejected, (state, action) => {
        state.loadingRecommendationEvaluationManager = false;
        state.errorRecommendationEvaluationManager = action.payload;
      })
      //-----------------------update------------------------
      .addCase(UpdateRecommendationEvaluation.pending, (state, action) => {
        state.loadingRecommendationEvaluationManagerUpdate = true;
        state.RecommendationEvaluationManagerUpdate = action.payload;
        state.errorRecommendationEvaluationManagerUpdate = null;
      })
      .addCase(UpdateRecommendationEvaluation.fulfilled, (state, action) => {
        state.loadingRecommendationEvaluationManagerUpdate = false;
        state.RecommendationEvaluationManagerUpdate = action.payload;
      })
      .addCase(UpdateRecommendationEvaluation.rejected, (state, action) => {
        state.loadingRecommendationEvaluationManagerUpdate = false;
        state.errorRecommendationEvaluationManagerUpdate = action.payload;
      })

      //-------------GetRecommendationsDropDown---------------------
      .addCase(GetRecommendationsDropDown.pending, (state, action) => {
        state.loadingRecommendationEvaluationDropDown = true;
        state.RecommendationEvaluationDropDown = action.payload;
        state.errorRecommendationEvaluationDropDown = null;
      })
      .addCase(GetRecommendationsDropDown.fulfilled, (state, action) => {
        state.loadingRecommendationEvaluationDropDown = false;
        state.RecommendationEvaluationDropDown = action.payload;
      })
      .addCase(GetRecommendationsDropDown.rejected, (state, action) => {
        state.loadingRecommendationEvaluationDropDown = false;
        state.errorRecommendationEvaluationDropDown = action.payload;
      });
  },
});

export const { SetRecommendationEvaluationManager } =
  RecommendationEvaluationManager.actions;

export default RecommendationEvaluationManager.reducer;
